module.exports = __webpack_public_path__ + "a480c67f4fe79f957bb4eee78886b93f.MP3";